import React from 'react'

const ExternalIcon = () => {
	return (
		<svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M21.2882 0.114275L14.0294 0.00146484L16.7933 2.79354L8.75282 10.9159L10.5954 12.7773L18.6359 4.65492L21.3998 7.44699L21.2882 0.114275ZM16.8989 18.5863V10.1692L19.2904 7.75331V20.0022C19.2904 20.5545 18.8427 21.0022 18.2904 21.0022H1.5C0.947716 21.0022 0.5 20.5545 0.5 20.0022V3.02034C0.5 2.46806 0.947715 2.02034 1.5 2.02034H13.3297L10.9382 4.43621H2.89151V18.5863H16.8989Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export default ExternalIcon
